// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    TOGGLE_ACCORDION: 'TOGGLE_ACCORDION'
});



// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/actions-list.js